"use client";
import { useAppContext } from "@/providers/AppProvider";
import { useEffect } from "react";
import * as THREE from "three";

const ParticleBackground = () => {
    const { theme } = useAppContext();

    useEffect(() => {
        if (theme === "light") return;

        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(
            75,
            window.innerWidth / window.innerHeight,
            0.1,
            1000,
        );
        const renderer = new THREE.WebGLRenderer({ alpha: true }); // Enable alpha for transparency

        // Set background color to #121212
        renderer.setClearColor(0x121212, 1);
        renderer.setSize(window.innerWidth, window.innerHeight);
        document.body.appendChild(renderer.domElement);

        // Particle geometry and material
        const particleCount = 3000;
        const particles = new THREE.BufferGeometry();
        const positions = new Float32Array(particleCount * 3);
        const colors = new Float32Array(particleCount * 3);

        const particleColor = new THREE.Color(0xe0cada); // Particle color

        for (let i = 0; i < particleCount; i++) {
            // Randomize positions
            positions[i * 3] = (Math.random() - 0.5) * 200; // X position
            positions[i * 3 + 1] = (Math.random() - 0.5) * 200; // Y position
            positions[i * 3 + 2] = (Math.random() - 0.5) * 200; // Z position

            // Set particle color
            colors[i * 3] = particleColor.r; // R
            colors[i * 3 + 1] = particleColor.g; // G
            colors[i * 3 + 2] = particleColor.b; // B
        }

        particles.setAttribute(
            "position",
            new THREE.BufferAttribute(positions, 3),
        );
        particles.setAttribute("color", new THREE.BufferAttribute(colors, 3));

        // Particle material
        const particleMaterial = new THREE.PointsMaterial({
            size: 0.2,
            vertexColors: true,
            sizeAttenuation: true,
        });

        const particleSystem = new THREE.Points(particles, particleMaterial);
        scene.add(particleSystem);

        camera.position.set(0, 0, 100);

        const animate = () => {
            requestAnimationFrame(animate);

            // Rotate the particle system for a better view
            particleSystem.rotation.x -= 0.002;
            particleSystem.rotation.y -= 0.002;

            renderer.render(scene, camera);
        };

        animate();

        // Handle window resize
        const handleResize = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;

            // Update camera aspect ratio and renderer size
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            renderer.setSize(width, height);
        };

        window.addEventListener("resize", handleResize);

        // Clean up on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
            if (document.body.contains(renderer.domElement)) {
                document.body.removeChild(renderer.domElement);
            }
            renderer.dispose();
        };
    }, [theme]);

    return null;
};

export default ParticleBackground;
